import React, { forwardRef } from 'react'
import MessageBox from './MessageBox'
import { IoMdInformationCircle } from "react-icons/io";

const AdminCustomArea = forwardRef(({ type, placeHolder, onChange, name, value, className, error, rows, cols, noMargin, noBorder, id, maxlength, ...rest }, ref) => {
    return (
        <>
            <textarea
                name={name || ''}
                value={value || ''}
                onChange={onChange}
                placeholder={placeHolder || ''}
                ref={ref}
                rows={rows}
                cols={cols}
                id={id || "customArea"}
                data-test-id={id || "customArea"}
                maxlength={maxlength}
                {...rest}
                className={`custom-input ${!noBorder ? 'custom-input-border' : ''} w-100 custom-placeholder  theme-text-color  ${className || ''} ${!noMargin ? "mb-3" : ""} ${error && 'custom-input-error'}`} />
            {error && (<div className='d-flex align-items-center gap-1 mb-2'><IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} /><MessageBox text={`${error || ''}`} classname='errorred d-block' /></div>)}
        </>)
})

export default AdminCustomArea
